export default __webpack_public_path__ + "img/beneficios-bg-card-3.531542bf.png";